module.exports = __webpack_public_path__ + "static/media/config-view-example.b81555f9.png";